// src/components/styles.js
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const StyledCard = styled(Box)(({ theme }) => ({
  padding: 16,
  marginBottom: 12,
  backgroundColor: '#fff',
  borderBottom: '1px solid #ededed',
  width: '75%',
  margin: 'auto',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: 12,
  },
}));

export const StyledUnreadCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: 16,
  marginBottom: 12,
  background: 'white',
  borderBottom: '1px solid #ededed',
  width: '75%',
  margin: 'auto',

  '& .MuiTypography-root': { fontWeight: 500 },

  '&::before': {
    content: '""',
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#1976D2',
    position: 'absolute',
    left: -32,
    top: '50%',
    transform: 'translateY(-50%)',
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: 12,

    // don’t push the unread dot outside on mobile
    '&::before': {
      left: 8,
      top: 14,
      transform: 'none',
    },
  },
}));


/* Flex container that holds the medicine info and the badge */
export const StyledContent = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));


const statusStyles = (status, theme) => {
  switch (status) {
    case 'EXPIRED':
      return {
        backgroundColor: '#ff0000c2',
        // color: theme.palette.error.main,
        color:'#000'
      };
    case 'EXPIRING_1D':
      return {
        backgroundColor: '#ff000090',
        color:'#000'
      };
    case 'EXPIRING_1W':
      return {
        backgroundColor: '#ff890490',
        color: '#000' 
         };
    case 'EXPIRING_1M':
      return {
        backgroundColor: '#ffba0090',
        color: '#000',
      };
    case 'EXPIRING_3M':
    default:
      return {
        backgroundColor: '#ffc800',
        color: '#fff',
      };
  }
};

export const StyledExpiryBadge = styled(
  Box,
  { shouldForwardProp: (prop) => prop !== 'status' }
)(({ theme, status }) => ({
  width: 150,
  height: 30,
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...statusStyles(status, theme),
}));

/* Timestamp under each notification */
export const StyledTimestamp = styled(Typography)(() => ({
  marginTop: 8,
  color: 'rgba(0,0,0,0.6)',
}));
